/* SAGLOU · Guías y condiciones: apartado actual en el índice, índice plegado en móvil e índice de
   las políticas generado a partir de sus encabezados reales (solo si hay tres o más). */
(function () {
  'use strict';
  var desk = window.matchMedia('(min-width: 990px)');

  function watch(links) {
    if (!links.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        links.forEach(function (a) {
          var on = a.getAttribute('href') === '#' + e.target.id;
          a.classList.toggle('is-current', on);
          if (on) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current');
        });
      });
    }, { rootMargin: '-25% 0px -65% 0px' });
    links.forEach(function (a) {
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (t) io.observe(t);
      a.addEventListener('click', function () {
        if (t) window.setTimeout(function () { t.focus({ preventScroll: true }); }, 350);
        var box = a.closest('details');
        if (box && !desk.matches) box.open = false;
      });
    });
  }

  document.querySelectorAll('[data-sgn-guide]').forEach(function (root) {
    var box = root.querySelector('[data-sgn-toc]');
    if (box && !desk.matches) box.open = false;
    watch(Array.prototype.slice.call(root.querySelectorAll('[data-sgn-toc-link]')));
  });

  document.querySelectorAll('[data-sgn-legal]').forEach(function (root) {
    var text = root.querySelector('[data-sgn-legal-text]');
    var toc = root.querySelector('[data-sgn-legal-toc]');
    if (!text || !toc) return;
    var heads = Array.prototype.slice.call(text.querySelectorAll('h1, h2, h3, h4'));
    var numbered = heads.filter(function (h) { return /^\s*\d+\s*[.)]/.test(h.textContent); });
    if (numbered.length >= 3) heads = numbered;
    else {
      var top = heads.filter(function (h) { return h.tagName === 'H1' || h.tagName === 'H2'; });
      if (top.length >= 3) heads = top;
    }
    if (heads.length < 3) return;
    var list = toc.querySelector('[data-sgn-legal-list]');
    heads.forEach(function (h, k) {
      if (!h.id) h.id = 'sgn-l' + (k + 1);
      h.setAttribute('tabindex', '-1');
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });
    if (numbered.length >= 3) list.classList.add('is-numbered');
    toc.querySelector('[data-sgn-legal-count]').textContent = heads.length + ' apartados';
    toc.hidden = false;
    root.querySelector('.sgn-legal__body').classList.add('has-toc');
    if (!desk.matches) toc.querySelector('details').open = false;
    watch(Array.prototype.slice.call(list.querySelectorAll('a')));
  });
})();
